import React from 'react';
import { IconProps } from '../../../types/header.types';
import plusIcon from '../../../../assets/b59fabb7d0532200ac148b0e778500c9c64f7f06.svg';

const PlusIcon: React.FC<IconProps> = ({ 
  size = 18, 
  color = '#ffffff', 
  className = '' 
}) => {
  return (
    <div 
      className={`plus-icon ${className}`}
      style={{ 
        width: size, 
        height: size,
        '--icon-color': color 
      } as React.CSSProperties}
    >
      <img 
        src={plusIcon} 
        alt="Add" 
        width={size} 
        height={size}
      />
    </div>
  );
};

export default PlusIcon;
